class Config {
  private readonly SystemName = 'tomi2'
  private readonly isDevEnv = process.env.ctiEnv === 'development'
  private readonly Target = this.isDevEnv
    ? this.SystemName + '_dev'
    : this.SystemName
  // private readonly baseURL = this.isDevEnv
  //   ? 'https://api.' + this.SystemName + '.dev.cti-mobility.jp'
  //   : 'https://api.' + this.SystemName + '.cti-mobility.jp'
  readonly showOrderName = true  /* 利用者名を運行順のカードに表示 */

  private readonly Map: any = {
    center: {
      lat: 36.3596332,
      lng: 138.3303327
    },
    zoom: 14,
    DEV: {
      mapId: 'ece2e6a4eb5faeef705cf593',
      key: 'AIzaSyBxJ3S_TWeXam868GCBtvxohGjtaQ4JkII'
    },
    PROD: {
      // TODO prod-tomi2の設定に変更
      mapId: 'b0cafc7d4de7b8a16a71fda3',
      key: 'AIzaSyCGUGgI4fpLtQhTZ88QWreiCvBn1kpp3Uo'
    },
    v: 'quarterly',
    libraries: ['maps']
  }

  private readonly MapOptions: any = {
    center: this.centerCoordinates(),
    zoom: this.zoomLevel(),
    mapId: this.mapId(),
    maxZoom: 18,
    zoomControl: false,
    cameraControl: false,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    keyboardShortcuts: false,
    fullscreenControl: false,
    disableDefaultUI: true,
    gestureHandling: 'greedy',
    clickableIcons: false,
    disableDoubleClickZoom: true,
    headingInteractionEnabled: true,
    tiltInteractionEnabled: false
  }

  private readonly DEV_FirebaseConfig = {
    apiKey: 'AIzaSyBxJ3S_TWeXam868GCBtvxohGjtaQ4JkII',
    authDomain: 'dev-2026-core-project.firebaseapp.com',
    databaseURL: 'https://dev-2026-core-project-default-rtdb.firebaseio.com',
    projectId: 'dev-2026-core-project',
    storageBucket: 'dev-2026-core-project.firebasestorage.app',
    messagingSenderId: '596919312610',
    appId: '1:596919312610:web:6e4c160609013443f97ebb'
  }

  private readonly PROD_FirebaseConfig = {
    // TODO prod-tomi2の設定に変更
    apiKey: 'AIzaSyCGUGgI4fpLtQhTZ88QWreiCvBn1kpp3Uo',
    authDomain: 'tomi2-project.firebaseapp.com',
    databaseURL: 'https://tomi2-project-default-rtdb.firebaseio.com',
    projectId: 'tomi2-project',
    storageBucket: 'tomi2-project.firebasestorage.app',
    messagingSenderId: '117463871863',
    appId: '1:117463871863:web:005ae1052c2a9ff203f172'
  }

  private CollectionName: any = {
    Message: 'messages_' + this.Target,
    Operator: 'operators_' + this.Target
  }

  // baseURL(): any {
  //   return this.baseURL
  // }
  mapOptions(): any {
    return  this.MapOptions
  }
  centerCoordinates(): any {
    return this.Map.center
  }
  zoomLevel(): number {
    return this.Map.zoom
  }
  mapId(): string {
    return this.isDevEnv ? this.Map.DEV.mapId : this.Map.PROD.mapId
  }
  mapAPIkey(): string {
    return this.isDevEnv ? this.Map.DEV.key : this.Map.PROD.key
  }
  mapVersion(): string {
    return this.Map.v
  }
  mapLibraries(): [] {
    return this.Map.libraries
  }
  firebaseConfig(): any {
    return this.isDevEnv ? this.DEV_FirebaseConfig : this.PROD_FirebaseConfig
  }
  messageCollectionName(): string {
    return this.CollectionName.Message
  }
  operatorCollectionName(): string {
    return this.CollectionName.Operator
  }
}
const config = new Config()

export { config }
